import styles from '../Styles/Cta.module.css';
import Container from '../UI/Container';
import Button from '../UI/Button';

const Cta = () => {
  const handleWhatsApp = () => {
    const phone = '3125575616';
    const message = encodeURIComponent(
      'Hola, me gustaría recibir más información sobre sus servicios.'
    );
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <section className={styles.cta}>

      {/* ── Decorativos de fondo ── */}
      <div className={styles.orbTr} />
      <div className={styles.orbBl} />
      <div className={styles.orbCenter} />

      {/* Circuito esquina superior izquierda */}
      <svg
        className={`${styles.cornerCircuit} ${styles.cornerTl}`}
        width="160" height="160" viewBox="0 0 180 180" fill="none"
        aria-hidden="true"
      >
        <path d="M0 40 H30 V10 H80"          stroke="#00AACD" strokeWidth="1.5" />
        <path d="M0 80 H60 V50 H120"          stroke="#00AACD" strokeWidth="1" />
        <path d="M0 120 H20 V90 H70 V60 H140" stroke="#31216F" strokeWidth="1" />
        <circle cx="80"  cy="10" r="3" fill="#00AACD" />
        <circle cx="120" cy="50" r="2" fill="#00AACD" opacity="0.6" />
        <circle cx="140" cy="60" r="3" fill="#31216F" />
        <rect x="26" y="6" width="8" height="8" fill="none" stroke="#00AACD" strokeWidth="1" />
      </svg>

      {/* Circuito esquina inferior derecha */}
      <svg
        className={`${styles.cornerCircuit} ${styles.cornerBr}`}
        width="160" height="160" viewBox="0 0 180 180" fill="none"
        aria-hidden="true"
      >
        <path d="M0 40 H30 V10 H80"          stroke="#00AACD" strokeWidth="1.5" />
        <path d="M0 80 H60 V50 H120"          stroke="#00AACD" strokeWidth="1" />
        <path d="M0 120 H20 V90 H70 V60 H140" stroke="#31216F" strokeWidth="1" />
        <circle cx="80"  cy="10" r="3" fill="#00AACD" />
        <circle cx="120" cy="50" r="2" fill="#00AACD" opacity="0.6" />
        <circle cx="140" cy="60" r="3" fill="#31216F" />
      </svg>

      {/* ── Contenido ── */}
      <Container>
        <div className={styles.content}>

          {/* Título — Orbitron igual que el Hero */}
          <h2 className={styles.title}>
            ¿Necesitas una{' '}
            <span className={styles.titleHighlight}>solución tecnológica?</span>
            <span className={styles.titleUnderline} />
          </h2>

          {/* Descripción */}
          <p className={styles.description}>
            Contáctanos y recibe <strong>asesoría personalizada</strong>{' '}
            para encontrar la solución exacta que tu negocio necesita.
          </p>

          {/* CTA — wrapper radar + Button variante whatsapp */}
          <div className={styles.btnWrap}>
            <Button variant="whatsapp" onClick={handleWhatsApp}>
              Cotizar por WhatsApp
            </Button>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default Cta;